import styled from 'styled-components';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 650px;
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;

    @media screen and (max-width: 420px ) {
      margin: 100px 30px 0px 30px;
      padding: 10px;
      width: auto;
    };
  }
`;

export const Text = styled(TextLayoutComponent)`
  ${({ margin }) => margin && `
    margin-bottom: 10px;
  `}
`;

export const Title = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;
